import React from 'react';
import PropTypes from 'prop-types';
import { translate } from '../utils/translations';
import { getEstCelAmbLlunes } from '../utils/utils';

const Sky = props => {
    const { data, language } = props;

    return (
        <div className="wrapper-data-48h mc-widget-sky">
            {/* Label */}
            <div className="wrapper-data-48h__labels mc-widget-sky__labels">
                <div className="mc-widget-sky__label">
                    <h3>{translate(language, 'municipal48h_cel')}</h3>
                </div>
            </div>
            {/* Data */}
            <div className="wrapper-data-48h__data mc-widget-sky__data">
                {data.map(
                    (data, index) =>
                        !data.valor ? (
                            <span key={index} />
                        ) : (
                            <span key={index}>
                                <img
                                    key={index}
                                    src={getEstCelAmbLlunes(data.valor, index)}
                                    alt=""
                                />
                            </span>
                        )
                )}
            </div>
        </div>
    );
};

Sky.propTypes = {
    data: PropTypes.arrayOf(
        PropTypes.shape({
            data: PropTypes.string,
            valor: PropTypes.number,
        })
    ),
    language: PropTypes.string,
};

export default Sky;



// WEBPACK FOOTER //
// ./src/partials/Sky.js